export default __webpack_public_path__ + "static/media/zh-hk.6d5d7395.svg";